export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "For Businesses", to: "/for-businesses" },
  { label: "For Professionals", to: "/for-professionals" },
  { label: "Packages & Pricing", to: "/pricing" },
  { label: "Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    key: "people-advisory",
    title: "People Advisory",
    tag: "For Businesses",
    variant: "forest",
    blurb:
      "Fractional HR consulting, HR operations, onboarding, employee experience, HR process development, and strategic people support.",
    to: "/for-businesses",
  },
  {
    key: "talent-acquisition",
    title: "Talent Acquisition",
    tag: "For Businesses",
    variant: "champagne",
    blurb:
      "Recruitment strategy, candidate sourcing, screening, interview coordination, job descriptions, and end-to-end recruiting support.",
    to: "/for-businesses",
  },
  {
    key: "career-atelier",
    title: "Career Atelier",
    tag: "For Professionals",
    variant: "espresso",
    blurb:
      "Professional resume writing, resume revamps, LinkedIn optimization, cover letters, interview preparation, and career consultations.",
    to: "/for-professionals",
  },
];

export const PILLARS = [
  { title: "Personalized, Boutique Experience", desc: "Senior-level attention and bespoke solutions, never a one-size-fits-all template." },
  { title: "Practical HR Expertise", desc: "MBA-educated, PHR-certified guidance grounded in real operational experience." },
  { title: "Flexible, Fully Virtual Services", desc: "100% virtual engagements that scale to your needs and timeline." },
  { title: "People-First Solutions", desc: "People sit at the center of every strategy we design and every decision we guide." },
];
